var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableDialog',{attrs:{"value":_vm.value,"exclude":_vm.exclude,"headers":_vm.headers,"title":_vm.title},on:{"input":function($event){return _vm.$emit('input',$event)},"apply":function($event){return _vm.$emit('apply',$event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }